module.exports = __webpack_public_path__ + "static/media/img-122.cada2ba0.jpg";